import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import authActions from '../store/actions/auth.action';
import timeDepositActions from '../store/actions/timeDeposit.action';
import 'url-search-params-polyfill';

class Main extends Component {
  componentDidMount() {
    const { location, refresh, listTimeDeposits } = this.props;

    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');

    refresh(token);
    listTimeDeposits();

  }

  render() {
    const { isAuthorized, initPage } = this.props;

    if (isAuthorized && initPage) {
      return <Redirect to={initPage} />;
    }

    return <span />;
  }
}

const mapStateToProps = state => ({
  isAuthorized: state.auth.isAuthorized,
  initPage: state.auth.initPage
});

const mapDispatchToProps = dispatch => {
  return {
    refresh: token => dispatch(authActions.refresh(token)),
    listTimeDeposits: () => dispatch(timeDepositActions.listTimeDeposits())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);
